import { BACKEND_PRIVATE } from '../../base'

export async function generateJobDescription(title: string, requiredSkills: Array<string>) {
  return BACKEND_PRIVATE.post<{ id: string }>('/me/ai/jobs/generate-description', {
    payload: {
      title,
      requiredSkills,
    },
  })
}

export async function getJobDescription(id: string) {
  return BACKEND_PRIVATE.get<{ response: { text: string } }>('/me/ai/jobs/get-job', { params: { id } })
}

export async function getAiRecommendedListFreelancers(vacancyId: string) {
  return BACKEND_PRIVATE.get<LX.Paginated<{ freelancers: LX.AIRecommendedTalent[] }>>('/me/ai/recommendation/list-freelancers-by-vacancy', {
    params: { id: vacancyId },
  })
}

export async function feedbackByVacancy(vacancyId: string, score: 0 | 1, comment: string) {
  return BACKEND_PRIVATE.post('/me/ai/recommendation/feedback-by-vacancy', {
    payload: {
      vacancyId,
      score,
      comment,
    },
  })
}

export async function generateByVacancy(vacancyId: string) {
  return BACKEND_PRIVATE.post('/me/ai/recommendation/generate-by-vacancy', null, {
    params: { id: vacancyId },
  })
}
